import { useEffect, useState } from "react";
import { useWeb3Ts } from "../context/Web3TsContext";
import { useWindowResize } from "./useWindowResize";
export const useContractAddress = (props?: { autoShort?: boolean }) => {
 const { width } = useWindowResize();
 const { config } = useWeb3Ts();
 const [address, setAddress] = useState<string>(
  config.mainContract.contractAddress
 );
 const shortAddress = `${config.mainContract.contractAddress.substring(
  0,
  7
 )}...${config.mainContract.contractAddress.substring(
  config.mainContract.contractAddress.length - 5
 )}`;
 useEffect(() => {
  if (props?.autoShort && width) {
   if (width < 720) {
    setAddress(shortAddress);
   } else {
    setAddress(config.mainContract.contractAddress);
   }
  }
 }, [props?.autoShort, width, config.mainContract.contractAddress]);
 return {
  address,
  shortAddress,
 };
};
